// Shared blur prevention state for web touch devices
// This module-level ref can be accessed by both generateSchemaForm and handleFieldType
// to coordinate blur prevention and prevent form remounting

import { Platform } from 'react-native';

export const blurPreventionState = {
  isPreventingBlur: false,
  preventionStartTime: 0,
  preventionTimeout: null as NodeJS.Timeout | null,
  
  startPrevention() {
    if (Platform.OS === 'web') {
      this.isPreventingBlur = true;
      this.preventionStartTime = typeof performance !== 'undefined' ? performance.now() : Date.now();
      
      // Clear any existing timeout
      if (this.preventionTimeout) {
        clearTimeout(this.preventionTimeout);
      }
      
      // Auto-clear after 2 seconds to prevent getting stuck
      this.preventionTimeout = setTimeout(() => {
        this.isPreventingBlur = false;
        this.preventionTimeout = null;
      }, 2000);
    }
  },
  
  stopPrevention() {
    if (this.preventionTimeout) {
      clearTimeout(this.preventionTimeout);
      this.preventionTimeout = null;
    }
    this.isPreventingBlur = false;
  },
  
  isActive() {
    if (Platform.OS !== 'web') return false;
    if (!this.isPreventingBlur) return false;
    
    // Check if prevention is still within the time window
    const now = typeof performance !== 'undefined' ? performance.now() : Date.now();
    const elapsed = now - this.preventionStartTime;
    
    // If more than 2 seconds have passed, consider it inactive
    if (elapsed > 2000) {
      this.stopPrevention();
      return false;
    }
    
    return true;
  }
};



